module Meevo.Plugins.EmployeeTemplates {
    "use strict";

    /**
    * Service Commissions Section of Employee Template
    */
    export class ServiceCommissionsSection extends Meevo.Components.BaseClasses.ServiceCommissionsSection {
        
    }
}